module.exports = __webpack_public_path__ + "static/media/Lot_Land_Loans.9d4494a5.png";